import { render, staticRenderFns } from "./AccBinding.vue?vue&type=template&id=9cef36fa&scoped=true"
import script from "./AccBinding.vue?vue&type=script&lang=js"
export * from "./AccBinding.vue?vue&type=script&lang=js"
import style0 from "./AccBinding.vue?vue&type=style&index=0&id=9cef36fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cef36fa",
  null
  
)

export default component.exports